import { render, staticRenderFns } from "./gameDetail.vue?vue&type=template&id=30fcd00e&scoped=true&"
import script from "./gameDetail.vue?vue&type=script&lang=js&"
export * from "./gameDetail.vue?vue&type=script&lang=js&"
import style0 from "./gameDetail.vue?vue&type=style&index=0&id=30fcd00e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fcd00e",
  null
  
)

export default component.exports